import React, { Component } from "react";

class TableSubDataRanges extends Component {
    monetaryFormat = (value) => {
        const formatter = new Intl.NumberFormat("pt-BR", {
            style: "decimal",
            maximumFractionDigits: 0,
        });
        return formatter.format(value);
    };

    areaFormat = (value) => {
        const formatter = new Intl.NumberFormat("pt-BR", {
            style: "decimal",
            maximumFractionDigits: 2,
        });
        return formatter.format(value);
    };

    renderTable = (label, data, fulldata, tipo, titulo, subTitulo) => {
        if (!data || Object.keys(data).length === 0) {
            return null;
        }

        var total = 0;
        var porcentagem = 0;
        var media_preco = 0;
        var media_preco_metro = 0;
        var media_area_util = 0;

        const entries = Object.entries(data);
        const numItems = entries.length;

        entries.forEach(([key, item]) => {
            total += item.total;
            porcentagem += item.porcentagem_sobre_tipo;
            media_preco += item.media_preco;
            media_preco_metro += item.media_preco_metro;
            media_area_util += item.media_area_util;
        });

        if (total === fulldata.total) {
            media_preco = fulldata.media_preco;
            media_preco_metro = fulldata.media_preco_metro;
            media_area_util = fulldata.media_area_util;
        } else {
            media_preco = media_preco / numItems;
            media_preco_metro = media_preco_metro / numItems;
            media_area_util = media_area_util / numItems;
        }

        return (
            <>
                <h3 style={{ textAlign: 'center' }}>{titulo}</h3>
                <h5 style={{ textAlign: 'center' }}>{subTitulo}</h5>

                <div style={{ marginBottom: "20px" }}>
                    <table className="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th>{label}</th>
                                <th>Nº de Imóveis</th>
                                <th>% sobre {tipo}</th>
                                <th>% sobre total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {entries.map(([key, item], i) => (
                                <tr key={i}>
                                    <td>{key}</td>
                                    <td>{item.total.toLocaleString("pt-BR")}</td>
                                    <td>{Number(item.porcentagem_sobre_tipo).toFixed(2).toLocaleString().replace(".", ",")}%</td>
                                    <td>{Number(item.porcentagem_sobre_total).toFixed(2).toLocaleString().replace(".", ",")}%</td>
                                </tr>
                            ))}
                            <tr>
                                <td>Total</td>
                                <td>{total.toLocaleString("pt-BR")}</td>
                                <td colSpan={2}>{Number(porcentagem).toFixed(2).toLocaleString().replace(".", ",")}%</td>
                            </tr>
                            <tr>
                                <td>Média {label}</td>
                                {label === "Preço" && (<td colSpan={3}>R$ {this.monetaryFormat(media_preco)}</td>)}
                                {label === "Metragem" && (<td colSpan={3}>{this.areaFormat(media_area_util)} m²</td>)}
                                {label === "R$/M²" && (<td colSpan={3}>R$ {this.monetaryFormat(media_preco_metro)}</td>)}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </>

        );
    };


    render() {
        const { tipo, data } = this.props;
        if (!data || !data.tipos || !data.tipos[tipo]) {
            return null;
        }

        const fulldata = data.tipos[tipo];

        if (fulldata.preco.length == 0 && fulldata.area_util.length == 0 && fulldata.preco_metro_util.length == 0) {
            return null;
        }
        return (
            <>
                {this.renderTable("Preço", fulldata.preco, fulldata, tipo, "Oferta por faixa de Preço (R$)", "")}
                {this.renderTable("Metragem", fulldata.area_util, fulldata, tipo, "Oferta por faixa de Metragem (m)", "")}
                {this.renderTable("R$/M²", fulldata.preco_metro_util, fulldata, tipo, "Oferta por Preço m² (R$/m²)", "")}
            </>
        );
    }
}

export default TableSubDataRanges;
